import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
} from '@mui/x-data-grid'
import { Button, MenuItem } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import PDFDocument from './PDFDocument'
import { useContext, useState } from 'react'
import { TenantSettingsContext, UserContext } from '../../App'
import { downloadPdf } from '../../helpers/downloadPdf'
import PrintButton from '../PDF/PrintButton'

const CustomExportButton = ({ columns, rows, documentTitle, csvOptions }) => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const { user } = useContext(UserContext)
  const printedBy = `${user.firstName} ${user.lastName}`
  const [pdfLoading, setPdfLoading] = useState(false)

  // Deliberately not <PDFDownloadLink> - it regenerates its PDF reactively
  // whenever `rows`/`columns` change identity, which happens on almost every
  // render for a live grid, and @react-pdf/renderer throws internally if a
  // new render starts while a previous one is still in flight. Generating
  // on demand at click time avoids that entirely.
  const handleExportPdf = async () => {
    setPdfLoading(true)
    try {
      await downloadPdf(
        <PDFDocument
          columns={columns}
          rows={rows}
          orgLogo={orgSettings?.logo}
          printedBy={printedBy}
          documentTitle={documentTitle}
        />,
        'export.pdf',
      )
    } catch (e) {
      console.error(e)
    } finally {
      setPdfLoading(false)
    }
  }

  return (
    <GridToolbarExportContainer>
      <GridCsvExportMenuItem options={csvOptions}/>
      {columns?.some((x) => x.renderForExport) && (
        <MenuItem disabled={pdfLoading} onClick={handleExportPdf}>
          {pdfLoading ? 'Generating PDF…' : 'Export to PDF'}
        </MenuItem>
      )}
    </GridToolbarExportContainer>
  )
}

const CustomToolbar = ({
  rows = [],
  columns = [],
  columnVisibilityModel = {},
  printOptions = {},
  documentTitle,
  hideFilters,
  csvOptions,
  onPrint,
  printLabel,
}) => {
  const safeColumns = Array.isArray(columns) ? columns : []

  const requestedFields = Array.isArray(printOptions?.fields)
    ? printOptions.fields
    : []

  const exportColumns = safeColumns.filter((column) => {
    if (requestedFields.length) {
      return requestedFields.includes(column.field)
    }

    return columnVisibilityModel?.[column.field] !== false
  })

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      {!hideFilters && <GridToolbarFilterButton />}
      <GridToolbarDensitySelector />

      {/* A screen with its own branded PDF replaces the stock export menu
          with a Print button; everywhere else keeps CSV (and legacy PDF). */}
      {onPrint ? (
        <PrintButton onPrint={onPrint} label={printLabel} />
      ) : (
        <CustomExportButton
          rows={rows}
          columns={exportColumns}
          documentTitle={documentTitle}
          csvOptions={csvOptions}
        />
      )}
    </GridToolbarContainer>
  )
}

export default CustomToolbar
